<template>
  <!--  选择栏目-领域   -->
  <div class="SizerFrame main">
    <div class="SizerFrameContent">
      <el-row class="flex">
        <el-col :xs="24" :sm="2" class="Title">领域</el-col>
        <el-col :xs="24" :sm="22" class="Tags">
          <div class="button" :class="[fieldSelect.id == item.id ? 'buttonActive' :'']"
            v-for="(item,index) in fieldList" :key="index" @click="selectChange('fieldSelect',item)">
            {{item.title}}
          </div>
          <div class="button">
            更多 >>
          </div>
        </el-col>
      </el-row>
      <el-row class="flex">
        <el-col :xs="24" :sm="2" class="Title">时间</el-col>
        <el-col :xs="24" :sm="22" class="Tags">
          <div class="button" :class="[timeSelect.id == item.id ? 'buttonActive' :'']" v-for="(item,index) in timeList"
            :key="index" @click="selectChange('timeSelect',item)">
            {{item.title}}
          </div>
          <!-- <div class="button" v-for="(item,index) in timeList" :key="index">
            {{item.title}}
          </div> -->
          <div class="button">
            更多 >>
          </div>
        </el-col>
      </el-row>
      <el-row class="flex">
        <el-col :xs="24" :sm="2" class="Title">地区</el-col>
        <el-col :xs="24" :sm="22" class="Tags">

          <!-- <div class="button" v-for="(item,index) in regionList" :key="index">
            {{item.title}}
          </div> -->
          <div class="button" :class="[regionSelect.id == item.id ? 'buttonActive' :'']"
            v-for="(item,index) in regionList" :key="index" @click="selectChange('regionSelect',item)">
            {{item.title}}
          </div>
          <div class="button">
            更多 >>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>

</template>

<script>
  import axios from "axios"
  export default {
    props: {
      // list: Array,
    },
    components: {},
    data() {
      return {

        fieldList: [{ id: "0", title: "全部" }],//领域数据存储
        fieldSelect: { id: "0", title: "全部" },//领域选中,默认选中全部
        timeList: [{ id: "0", title: "全部" }],//时间数据存储
        timeSelect: { id: "0", title: "全部" },//时间选中
        regionList:
          [
            { id: "0", title: "全部" },
            { id: "3", title: "北京" },
            { id: "4", title: "上海" },
            { id: "5", title: "广州" },
            { id: "6", title: "深圳" }],// 地区
        regionSelect: { id: "0", title: "全部" },//地区选中
      };
    },
    created: function () {
      let self = this;
      //获取领域
      axios.get('/api/jointterritorytype', {
        params: {
        }
      })
        .then(function (response) {
          if (response.data.code == 0) {
            for (let i in response.data.data) {
              self.fieldList.push(response.data.data[i]);
            }
          }
        })
        .catch(function (error) {
          console.log(error);
        });
      //获取时间
      axios.get('/api/jointtimetype', {
        params: {
        }
      })
        .then(function (response) {
          if (response.data.code == 0) {
            for (let i in response.data.data) {
              self.timeList.push(response.data.data[i]);
            }
          }
        })
        .catch(function (error) {
          console.log(error);
        });

    },
    methods: {

      selectChange(select, item) {
        //用户切换选择按钮，给背景颜色
        this[select] = item;
        //同时触发上层
        this.$emit('selectChange',
          {
            "select": select,
            "item": item
          }
        );

      }
    },
  };
</script>

<style scoped>
  @media (max-width: 768px) {
    .SizerFrame .Title {
      margin-bottom: 15px;
    }

    .SizerFrame .flex {
      margin-left: 15px;
      margin-right: 15px;
      padding-top: 15px;
      padding-bottom: 15px;
    }

    .SizerFrame .button {
      margin-right: 15px;
    }
  }

  .SizerFrame {
    margin-top: 39px;
    background-color: #ffffff;
    border-radius: 25px;
  }

  .flex {
    /* display: flex;
    justify-content: left;
    flex-wrap: nowrap; */
    margin-left: 34px;
    margin-right: 34px;
    padding-top: 36px;
    padding-bottom: 26px;
    border-bottom: 1px solid #ededed;

  }

  .Title {
    font-size: 20px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    color: #262525;
    margin-top: 9px;
    /* margin-right: 24px; */
    /* text-align: center; */
  }

  .button {

    font-size: 16px;
    letter-spacing: 0px;
    color: #7E7E7E;
    opacity: 0.75;
    margin-right: 30px;
    /* margin-top: 12px; */
    margin-bottom: 12px;
    padding: 10px 15px;
    cursor: pointer;
  }

  .buttonActive {

    color: #ffffff;
    background-color: #ff00ff;
    border-radius: 21px;

  }

  .Tags {
    display: flex;
    justify-content: left;
    flex-wrap: wrap;
    /* margin-left: 24px; */
  }

  .SizerFrameContent>.flex:last-child {
    border-bottom: none;
  }
</style>